'use strict';

import defaultTemplate from '../../core/default.html';
import groupsListTemplate from './groups.list.html';

import Groups from './groups.ctrl';

function GroupsRouter($urlRouterProvider, $stateProvider) {
  $stateProvider
    .state('main.groups', {
      url: '/groups',
      template: defaultTemplate,
      resolve: {
        permission: ($q, utils) => {
          const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';
          let orgInfo = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);
          let hasFeatureG = utils.hasFeature(orgInfo, 'g');
          return hasFeatureG ? $q.resolve() : $q.reject();
        }
      }
    })
    .state('main.groups.list', {
      url: '/list',
      template: groupsListTemplate,
      controller: 'GroupsListController as vm',
      resolve: {
        permission: ($q, utils, PermissionsService) => {
          return PermissionsService.canIViewGroupList()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.groups.list');
        }
      }
    });
}

export default angular
  .module('groups.router', [
    Groups
  ])
  .config(GroupsRouter)
  .name;
